import React, { ReactNode, useState } from "react";
import PlainButton from "../../components/Button/PlainButton/PlainButton";
import Text from "../Text/Text";
import GetText from "../../i18n/GetText";
import styles from "./Tags.module.scss";
import LookIcon from "../../icons/LookIcon";

const Tags = ({ children, truncateAt }: Props) => {
  const [showRemaining, setShowRemaining] = useState<boolean>(false);
  const truncatedTagsArray: ReactNode[] = children.slice(0, truncateAt);
  const remainingTagArray: ReactNode[] = children.slice(truncateAt);

  return (
    <>
      {truncateAt ? (
        children.length < truncateAt + 1 ? (
          children
        ) : (
          <>
            {truncatedTagsArray}
            {showRemaining && remainingTagArray}
            <PlainButton
              type="button"
              className={styles.viewButton}
              onClick={() => setShowRemaining(!showRemaining)}
              renderLeft={<LookIcon className={styles.icon} />}
            >
              <Text variant="default" as="span">
                {showRemaining ? (
                  <GetText id="view-less" />
                ) : (
                  <GetText id="view-more" />
                )}
              </Text>
            </PlainButton>
          </>
        )
      ) : (
        children
      )}
    </>
  );
};

export default Tags;

type Props = {
  className?: string;
  children: ReactNode[];
  truncateAt: number;
};
